import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import AfsTableWrapper from '../shared/AfsTableWrapper';
import PropTypes from 'prop-types';
import { matchingTypeAnswerSummaryPropType } from '../../../common/propTypes';
import t from '@instructure/quiz-i18n/format-message';
import { AfsPartsContainer } from '../shared/AfsPartsContainer/presenter';
import AggregationTable from '../shared/AggregationTable';
import MatchingTypeTable from './MatchingTypeTable';
export var OrderingType = /*#__PURE__*/function (_Component) {
  function OrderingType() {
    var _this2;
    _classCallCheck(this, OrderingType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, OrderingType, [].concat(args));
    _defineProperty(_this2, "translateBody", function (index) {
      return "".concat(t('Order'), " ").concat(index);
    });
    _defineProperty(_this2, "updateAnswerBody", function (answerSummary) {
      var answerSummaryCopy = _objectSpread({}, answerSummary);
      Object.keys(answerSummaryCopy.questions).forEach(function (questionKey) {
        Object.keys(answerSummaryCopy.questions[questionKey].answers).forEach(function (answerKey) {
          var detail = answerSummaryCopy.questions[questionKey].answers[answerKey];
          answerSummaryCopy.questions[questionKey].answers[answerKey] = _objectSpread(_objectSpread({}, detail), {}, {
            // Body cannot be used because because re-render of the component add Order
            // as many time we have to re-render. Only re-assignment works.
            body: _this2.translateBody(Number(answerKey) + 1)
          });
        });
      });
      return answerSummaryCopy;
    });
    _defineProperty(_this2, "render", function () {
      var _this2$props = _this2.props,
        itemId = _this2$props.itemId,
        answerSummary = _this2$props.answerSummary;
      var updatedAnswerSummary = _this2.updateAnswerBody(answerSummary);
      return /*#__PURE__*/React.createElement(AfsTableWrapper, null, /*#__PURE__*/React.createElement(AfsPartsContainer, {
        afsTable: /*#__PURE__*/React.createElement(MatchingTypeTable, {
          itemId: itemId,
          answerSummary: updatedAnswerSummary,
          firstColumnName: t('Answer')
        }),
        aggregationTable: /*#__PURE__*/React.createElement(AggregationTable, {
          itemId: itemId,
          answerSummary: updatedAnswerSummary
        })
      }));
    });
    return _this2;
  }
  _inherits(OrderingType, _Component);
  return _createClass(OrderingType);
}(Component);
_defineProperty(OrderingType, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: matchingTypeAnswerSummaryPropType.isRequired
}.isRequired);